"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var java_script_processor_1 = require("./java-script-processor");
exports.JavaScriptProcessor = java_script_processor_1.JavaScriptProcessor;
